/** Regex pattern for company tax number
 * @example "12345678-1-12"
 */
export const companyTaxIdPattern = /^\d{8}-\d{1}-\d{2}$/;
/** Regex pattern for valid hungarian post code
 * @example: 2000
 */
export const hungarianPostCodePattern = /^\d{4}$/u;

/** Regex pattern for valid foreign post code
 * @example: ABC123, 123456
 */
export const foreignPostCodePattern = /^(\d|[A-Z-/]){4,10}$/u;

/** Regex for normalize text from special characters and accents
 * @example: ÖÜÓŐÚÉÁŰ => OUOOUEAU
 */
export const normalizePattern = /[\u0300-\u036f]/g;

/**
 * Regex pattern for e-mail addresses, identical to BE pattern
 */
export const emailPattern =
	/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

/**
 * Regex pattern for name texts without numbers
 */
export const withoutNumber = /^[^0-9]*$/;

/**
 * Regex pattern for hungarian texts without space
 */
export const hungarianAlphabets = /^[a-zA-ZéáűöőúóüíÉÁŰÖŐÚÜÓÍ]+$/u;

/** Regex pattern for valid ownership share
 * @example "2000/10000"
 */
export const ownershipSharePattern = /^[1-9]\d*\/[1-9]\d*$/u;

/** Regex pattern for valid id or address card
 * @example "123456AB"
 */
export const idCardPattern = /^\d{6}[A-Z]{2}$/u;

/** Regex pattern for valid id number (tax)
 * @example "8123456789"
 */
export const idNumberPattern = /^8\d{0,9}$/u;

/** Regex pattern for valid personal id number
 * @example "1-123456-1234"
 */
export const personalIdPattern = /^\d\d{6}\d{4}$/u;

/** Regex pattern for valid driving licence
 * @example "CS123456"
 */
export const drivingLicencePattern = /^[A-Z]{2}\d{6}$/u;

/** Regex pattern for valid passport
 * @example "AB1234567"
 */
export const passportPattern = /^[A-Z]{2}\d{7}$/u;

/** Regex pattern for mobile phone number
 * @example "06201234567"
 */
export const mobilPhoneNumberPattern = /^[0-9]{11}$/u;

/** Regex pattern for mobile phone number
 * @example "201234567"
 */
export const mobilePhoneWithPrefixPattern = /^(20|30|31|50|70)\d{7}$/;

/** Regex pattern for phone number without prefix
 * @example "201234567"
 */
export const phoneNumberWithoutPrefixPattern = /^[0-9]{9}$/u;

/** Regex pattern for valid tax id
 * @example "8123456789"
 */
export const taxIdPattern = /^8\d{9}$/;

/** Regex pattern for possibly valid US tax id (ITIN)
 * @example "999-88-7777"
 * @link https://www.offshorecompanycorp.com/company-formation/jurisdiction/usa/itin-application
 */
export const itinPattern = /(\d{3})([-]?)(\d{2})([-]?)(\d{4})$/u;

/** Regex pattern for only numbers ang letters
 * Minimum 1 character
 * @example "A69"
 */
export const onlyNumbersAndLettersWithMinimum1Character = /^[a-zA-Z0-9]+$/;

/**
 * Regex pattern for birthplaces
 */
export const birthPlacePattern = /^[a-zA-Z0-9-., áÁéÉíÍóÓöÖőŐúÚüÜűŰ]+$/u;

/**
 * Regex pattern for localities
 */
export const localityPattern = /^[a-zA-Z-. áÁéÉíÍóÓöÖőŐúÚüÜűŰ]+$/u;

/**
 * Regex pattern for hungarian names
 * @description single whitespace, dash and dot enabled beside hungarian characters
 * @example Szabóné Kiss, Szabó-Kiss, Hajdú B. István
 */
export const hungarianNamesPattern = /^[a-zA-Z-. áÁéÉíÍóÓöÖőŐúÚüÜűŰ]{1,30}$/u;

/**
 * Regex for foreign identification documents
 */
export const foreignDocumentPattern = /^[a-zA-Z0-9]{1,20}$/u;

/**
 * Regex for id card or driving licence or passport
 * @example 123456AB
 * @example XY987654
 * @example AB1234567
 */
export const allIdDocumentsPattern = /^(\d{6}[A-Z]{2}|[A-Z]{2}\d{6,7})$/u;

/**
 * Regex for id card or driving licence
 * @example 123456AB
 * @example XY987654
 */
export const drivingLicenceOrIdCardPattern = /^(\d{6}[A-Z]{2}|[A-Z]{2}\d{6})$/u;

/**
 * Regex for enabling only numeric characters
 */
export const onlyNumericCharactersPattern = /^[0-9]*$/u;

/**
 * Regex for detailed addresses.
 */
export const addressPattern = /^[a-zA-Z0-9-.,:;/ áÁéÉíÍóÓöÖőŐúÚüÜűŰ]+$/u;

/**
 * Regex for dates retrieved from OCR
 */
export const ocrDatePattern = /^\d{4}\.\d{2}\.\d{2}\.$/;

/**
 * Regex for float numbers with maximum two decimal digits
 */
export const maximumTwoDecimalFloatPattern = /^\d+(\.\d{1,2})?$/;

/**
 * Regex for validate 6 char long OTP code
 */
export const otp6CharPattern = /^[A-Za-z0-9]{6}$/;
